/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Basic_ExportInputs */



/**
* | output |
* | --- |
* | "Basic Closed Caption File Export (excludes SCC, STL, and MCC)" |
*
* @param {Signup_Compare_Basic_ExportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_basic_export = /** @type {((inputs?: Signup_Compare_Basic_ExportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Basic_ExportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basic Closed Caption File Export (excludes SCC, STL, and MCC)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Basic Closed Caption File Export (excludes SCC, STL, and MCC)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Basic Closed Caption File Export (excludes SCC, STL, and MCC)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Basic Closed Caption File Export (excludes SCC, STL, and MCC)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Basic Closed Caption File Export (excludes SCC, STL, and MCC)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Basic Closed Caption File Export (excludes SCC, STL, and MCC)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Basic Closed Caption File Export (excludes SCC, STL, and MCC)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Basic Closed Caption File Export (excludes SCC, STL, and MCC)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Basic Closed Caption File Export (excludes SCC, STL, and MCC)")
	return /** @type {LocalizedString} */ ("Basic Closed Caption File Export (excludes SCC, STL, and MCC)")
});